
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    props: {
        value: {
            type: Object,
            default () { return {} }
        },
        statesFilter: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            editingFile: {
                metadata: {
                    available_states: []
                }
            },
        }
    },
    computed: {
        ...mapGetters(['usStates', 'survey'])
    },
    watch: {
        value (newFile = {}) {
            this.editingFile = _.cloneDeep({ ...this.editingFile, ...newFile })
            this.$set(this.editingFile.metadata, 'available_states', this.editingFile?.metadata?.available_states || [])
        }
    },
    created () {
        this.editingFile = _.cloneDeep({ ...this.editingFile, ...this.value })
        this.$set(this.editingFile.metadata, 'available_states', this.editingFile?.metadata?.available_states || [])
    },
    mounted () {
        this.setGlobal('$editFileForm', this)
    },
    methods: {
        async saveChanges () {
            // Plan files live in Oracle and must update via /plan-files/; group-plan
            // files stay on /files/. Routing a plan file through /files/ would edit an
            // unrelated Flow UploadedFile with the same id. See drschoice/flow#592.
            const isPlanFile = !!this.editingFile?.plan_id && !this.editingFile?.group_plan_id
            const result = await this.$try(isPlanFile ? 'updatePlanFile' : 'updateFile', { ...this.editingFile })
            if (result.success) {
                this.$emit('input', result)
            }
        },
    }
}
